import React from 'react';
import PropTypes from 'prop-types';
import { isNumeric, isUuid, createCustomPropType } from '../../../js/app/react/validators';
import { ASSUMPTIONS } from '../../FinancialPlan/Explanations/ExplanationsConst';

const MobileExplanationsWithMenuView = ({
  sections,
  goalId,
  clientId,
  selectedSection,
  setSelectedSection,
}) => (
  <div className="mobile-financial-plan-explanations-section">
    <ul className="mobile-financial-plan-explanations-section-ul">
      {sections.filter(section => section !== ASSUMPTIONS).map(section => (
        <li key={section} className="mobile-financial-plan-explanations-section-li">
          <button
            type="button"
            onClick={setSelectedSection(goalId, section, clientId)}
            className={
              selectedSection === section
                ? 'mobile-financial-plan-explanations-section-button selected'
                : 'mobile-financial-plan-explanations-section-button'
            }
          >
            {section}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

MobileExplanationsWithMenuView.defaultProps = {
  selectedSection: null,
};

MobileExplanationsWithMenuView.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  selectedSection: PropTypes.string,
  setSelectedSection: PropTypes.func.isRequired,
};

export default MobileExplanationsWithMenuView;
